// import React from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Form,
//   Button,
  
// } from "react-bootstrap";

// export default function MFP() {
// //    const [open, setOpen] = useState(0);
  

//   return (
//     <>
//     <div className="bg-light py-5">
    
//            <section className="bg-light">
//                   <Container>
//                     <Row className="g-4 align-items-start">
//                       {/* LEFT CONTENT */}
//                       <Col lg={8}>
//                               <div>
//                                   <h1>Mega Food Park from MOFPI</h1>

//                                   <h2>Objective:</h2>
//                                   <p>The main objective of the Mega Food Park Scheme (MFPS) is to provide modern infrastructure facilities for food processing along the value chain from farm to market. Agriculture, transportation, logistics and central processing centers. The main feature of the scheme is a group-based approach. The scheme will be needs-based and make it easier for food processing companies to comply with environmental and safety standards.</p>

//                                   <h2>About the Mega Food Park Scheme</h2>
//                                   <p>The Mega Food Park Scheme aims to provide a mechanism to connect agricultural production to the market, leading the way between farmers, processors and retailers in order to maximize the added value of waste minimize, increase farmers' incomes and create employment opportunities in rural areas. This scheme is mainly based on the "cluster" approach and provides for the creation of a state-of-the-art supporting infrastructure in a clearly delimited agricultural / horticultural zone for the establishment of state-of-the-art food processing units on the provided industrial areas Supply chain infrastructure that includes collection centers, primary processing centers, central processing centers, cold chain and around 25 - 30 fully developed packages for you to set up food processing</p>


//                               </div>
//                         </Col>
//                                 <Col lg={4}>
//                                              <div className="p-4 shadow rounded right-form">
//                                                <Form>
//                                                  <Form.Control className="mb-3" placeholder="Name" />
//                                                  <Form.Control className="mb-3" placeholder="Email" />
//                                                  <Form.Control className="mb-3" placeholder="Phone" />
//                                                  <Form.Control className="mb-3" placeholder="Subject" />
//                                                  <Button className="w-100">Get Started</Button>
//                                                </Form>
//                                              </div>
//                                </Col>
//             </Row>
//                       <Row className="g-4 align-items-start">
//                           <Col lg={12} xl={12}>
//                               <div>
//                                   <p>This project is carried out by a special purpose vehicle (SPV), which is a corporation registered under company law. The state government as well as the corporations and cooperatives are not obliged to set up their own special purpose vehicle for the implementation of the Mega Food Park project.</p>
//                                    <p>suggestions for applying for assistance under the Scheme will be solicited from time to time through an expression of interest.</p>
//                                    <p>So far, the following 22 Mega Food Parks are in operation:</p>
//                                    <p>1. Srini Mega Food Park, Chittoor, Andhra Pradesh.</p>
//                                    <p>2nd Godavari Mega Aqua Park, West Godavari, Andhra Pradesh.</p>

//                                    <p>3rd Northeast Mega Food Park, Nalbari, Assam.</p>
//                                    <p>4.Indus Best Mega Food Park, Raipur, Chhattisgarh</p>
//                                    <p>5.Gujarat Agro Mega Food Park, Surat, Gujarat.</p>
//                                    <p>6.Cremica mega Food Park, Una, Himachal Pradesh.</p>
//                                    <p>7.Integrated Mega Food Park, Tumkur, Karnataka.</p>
//                                    <p>8.Kerala Industrial Infrastructure Development Corporation (KINFRA) Mega Food Park, Palakkad, Kerala.</p>
//                                    <p>9.Indus Mega Food Park, Khargoan, Madhya Pradesh.</p>
//                                    <p>10.Avantee Mega Food Park, Dewas, Madhya Pradesh.</p>
//                                    <p>11.Paithan Mega Food Park, Aurangabad, Maharashtra.</p>
//                                    <p>12.Satara Mega Food Park, Satara, Maharashtra.</p>
//                                    <p>13.Zoram Mega Food Park, Kolasib, Mizoram.</p>
//                                    <p>14.MITS Mega Food Park, Rayagada, Odisha.</p>
//                                    <p>15 International Food Mega Park, Fazilka, Punjab.</p>
//                                    <p>16 Sukhjit Mega Food Park, Kapurthala, Punjab.</p>
//                                    <p>17th Greentech Mega Food Park, Ajmer, Rajasthan.</p>
//                                    <p>18th Smart Agro Mega Food Park, Nizamabad, Telangana.</p>
//                                    <p>19. Tripura Mega Food Park, West Tripura, Tripura.</p>
//                                    <p>20. Patañjali Food and Herb Park, Haridwar, Uttarakhand.</p>
//                                    <p>21 Himalayan Mega Food Park, Udham Singh Nagar, Uttarakhand.</p>
//                                    <p>22 Yangipur Bengal Mega Food Park, Murshidabad, West Bengal.</p>
//                                    <p>Entrepreneurs looking for fully developed industrial land to set up food processing units and other related services can turn to Mega Food Parks promoters</p>
                            
//                                   <h2>Project Components</h2>
//                                   <p>Supply Chain. These include the Collection Center (CC), Primary Processing Center (PPC), Central Processing Center (CPC) and cold chain infrastructure.</p>
//                                   <p>Collection Centers and Primary Processing Centers (PPC): These components have facilities for cleaning, sorting, sorting and packing, dry storage, specialized cold rooms including pre-cold rooms, ripening rooms, refrigerated trucks, mobile pre-coolers, pick-up trucks, mobile collection etc.</p>
//                                   <p>Central Processing Centers ( CPCs): This includes general facilities such as testing laboratories, cleaning, sorting, sorting and packaging facilities, dry storage facilities, specialized storage facilities including chambers with controlled atmosphere, pressure fans, storage with variable humidity, precooling chambers, maturing cold chambers, cold chain infrastructure including refrigerated trucks, packaging units, irradiation facilities , Steam sterilization units, steam generation units, food development and incubation centers, etc. business scheme that may vary from region to region. would be required for the establishment of CPCs and CCs in different locations in addition to the land required for the establishment of CPCs.</p>
//                                   <p>On average, each project will have approximately 25 - 30 food processing operations with a combined investment of Rs 250 crore, which ultimately results in annual sales of approx. Each MFF, when fully functional, will also benefit around 25,000 farmers.</p>
                              

//                                   <h2>Attendance pattern</h2>
//                                   <p>The scheme offers a capital grant equal to 50 percent of the eligible project cost * in general regions and 75 percent of the eligible project fee in difficult and mountainous areas; H. the northeast region, to the Sikkim, J&K, Himachal. belong to Pradesh. , Uttarakhand and ITDP notified the regions of the states with a majority of Rs. 50 million per company.</p>
//                                   <p>* Eligible project cost is described as the total cost of the project with the exception of the base fee, pre-operational fees and cash margin for working capital to be billed to the project controlling consultant. (PMC), up to 2% of the approved grant can be considered an eligible project cost.</p>
//                                   <p>In the interests of speedy implementation of the projects, the Ministry will designate a Scheme Management Agency (PMA) to provide management support, capacity building, coordination and follow-up to cover the costs of the above and various promotional activities. The Ministry will charge a separate amount of 5% of the available general grants.</p>
                              
//                                   <h2>Release of the grant</h2>
//                                   <p>The grant under the scheme is released in 4 instalments of 30%, 30%, 20% and 20%, subject to different parameters of the scheme according to the following scheme:</p>
//                                   <p>First instalment of 30% of the total delivery under the Scheme will be released after ensuring that the cost of the project components is at least 10% of the eligible contract value.</p>
//                                   <p>The second instalment, which makes up 30% of the approved provisioning aid, is issued after a proportionate expenditure by the special purpose vehicle from fixed-term loans and equity in the amount of the provision amount of the first tranche.</p>
//                                   <p>The third instalment of 20% of the approved supply subsidy is released after a proportional expenditure by the special purpose vehicle of the term mortgage and equity, which corresponds to the supply amount released as the 2nd instalment.</p>
//                                   <p>The fourth and final instalment of 20% of the Approved Deployment Aid will be launched, subject to the successful completion of the mission and the completion of operations, after ensuring that 100% of the SPV's expected contribution is made up of the mortgage and equity period the authorized Components of the project.</p>
                              
//                                   <h2>How Enrich Services Help you?</h2>
//                                   <p>Enrich services provide end to end Solution for Small and Medium Enterprise units to get registered, avail the Subsidies & Incentives offered by the Central and State Government from time to time. Out expert team will guide you to step by step to fill all details and will solve you queries with perfect solution.</p>
//                                   <p>Enrich services is one of the best organizations in the field of ISO and other certifications consultancy. Our Services are open 365 days with highly trained customer care executives for offering you the most Viable solutions to your organization. We shall be pleased to reply and comply any of your query. Please feel free to contact us and avail our highly affordable services</p>
                              
//                               </div>
//                               </Col>
//                           </Row>
//             </Container>
//         </section>
        
//     </div>
//     </>
//   );
// }

import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaCheckCircle,
  FaGlobe,
  FaList,
  FaIndustry,
  FaRocket,
  FaHandsHelping
} from "react-icons/fa";

export default function MFP() {
  return (
    <div className="bg-light py-5">
      <section className="bg-light">
        <Container>

          {/* TOP */}
          <Row className="g-4">
            <Col lg={12}>
              <h1>
                Mega Food Park Scheme
              </h1>

              <p>
                The Mega Food Park Scheme is a flagship initiative by the Government of India
                to transform the food processing sector through modern infrastructure and
                integrated supply chains.
              </p>

              <p>
                It connects farmers directly to markets, reducing wastage and improving income.
              </p>
            </Col>
          </Row>

          {/* OBJECTIVE */}
          <h2 className="section-title">
            <FaGlobe className="icon" /> Purpose of the Scheme
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Reduce post-harvest losses</li>
            <li><FaCheckCircle /> Increase farmers’ income</li>
            <li><FaCheckCircle /> Promote value addition</li>
            <li><FaCheckCircle /> Generate rural employment</li>
            <li><FaCheckCircle /> Strengthen food processing industry</li>
          </ul>

          {/* WORKING */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> How Mega Food Park Works
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Collection Centres & Primary Processing Units</li>
            <li><FaCheckCircle /> Cold storage and logistics facilities</li>
            <li><FaCheckCircle /> Central Processing Centre (CPC)</li>
            <li><FaCheckCircle /> Packaging, grading & testing units</li>
            <li><FaCheckCircle /> Plug-and-play industrial units</li>
          </ul>

          {/* STRUCTURE */}
          <h2 className="section-title">
            <FaList className="icon" /> Implementation Structure
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Managed through Special Purpose Vehicle (SPV)</li>
            <li><FaCheckCircle /> Includes private players & stakeholders</li>
            <li><FaCheckCircle /> Ensures efficient project execution</li>
          </ul>

          {/* FINANCIAL */}
          <h2 className="section-title">
            <FaRocket className="icon" /> Financial Assistance
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> 50% subsidy (general areas)</li>
            <li><FaCheckCircle /> 75% subsidy (hilly / NE regions)</li>
            <li><FaCheckCircle /> Maximum grant up to ₹50 Crores</li>
            <li><FaCheckCircle /> Installments: 30% + 30% + 20% + 20%</li>
          </ul>

          {/* IMPACT */}
          <h2 className="section-title">
            <FaGlobe className="icon" /> Impact & Benefits
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> ₹250 Cr investment per park</li>
            <li><FaCheckCircle /> 25–30 food processing units</li>
            <li><FaCheckCircle /> Benefits 25,000+ farmers</li>
            <li><FaCheckCircle /> Large-scale rural employment</li>
          </ul>

          {/* HELP */}
          <h2 className="section-title">
            <FaHandsHelping className="icon" /> How We Help You
          </h2>

          <p>
            At Apex Consultants, we provide complete support including project
            planning, documentation, subsidy applications, and coordination with
            authorities to ensure smooth approvals.
          </p>

          {/* WHY CHOOSE */}
          <h2 className="section-title">
            <FaRocket className="icon" /> Why Choose Us
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> End-to-end project support</li>
            <li><FaCheckCircle /> Expert documentation & compliance</li>
            <li><FaCheckCircle /> Faster approvals</li>
            <li><FaCheckCircle /> Customized strategies</li>
            <li><FaCheckCircle /> Dedicated support team</li>
          </ul>

        </Container>
      </section>
    </div>
  );
}